import { getOrCreateSessionId } from '@/utils/session-manager';
import { createBrowserClient } from '@/lib/supabase/client';

/**
 * Auth headers for the book routes: the browser session lives in localStorage, so the server
 * cannot see it as a cookie. Send the Bearer token plus the guest session id (see lib/auth/request-user.ts).
 */
export async function bookRequestHeaders(): Promise<Record<string, string>> {
  const sessionId = getOrCreateSessionId();
  let accessToken: string | undefined;
  try {
    const {
      data: { session },
    } = await createBrowserClient().auth.getSession();
    accessToken = session?.access_token;
  } catch {
    // Guests have no session: the jb_books cookie identifies them instead.
  }
  return {
    ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
    ...(sessionId ? { 'x-session-id': sessionId } : {}),
  };
}
